<div class="container">
    <div class="form-alert form-alert--error" *ngIf="showAlertError">
        <i class="form-alert-icon">⚠</i>
        <span>{{ errorMessage }}</span>
    </div>
    <section class="unlock-users">
        <form class="form-wrapper" #suppressedEmailForm="ngForm" (ngSubmit)="onSubmit(suppressedEmailForm)">
            <div class="form-inner">
                <div class="form-section">
                    <div class="form-group">
                        <label for="email-input" class="form-label form-label--required">Email</label>
                        <input id="email-input" class="form-input" type="email" placeholder="Ingresa email"
                            [(ngModel)]="emailRequest.email" name="emailInput" #emailModel="ngModel" required email
                            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                            [ngClass]="{'form-input--error': emailModel.invalid && emailModel.touched}">
                        <div *ngIf="emailModel.invalid && emailModel.touched" class="form-error-message">
                            <i class="form-error-icon">&#9888;</i>
                            <span class="form-error-text" *ngIf="emailModel.errors?.['required']">Este campo es requerido!</span>
                            <span class="form-error-text" *ngIf="emailModel.errors?.['email'] || emailModel.errors?.['pattern']">Ingresa un email válido</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <button type="button" class="form-btn form-btn--cancel" (click)="cancel(suppressedEmailForm)"
                    [ngClass]="{'is-active': suppressedEmailForm.valid}">Cancelar</button>
                <button type="submit" class="form-btn form-btn--submit" [ngClass]="{'is-valid': suppressedEmailForm.valid}"
                    [disabled]="suppressedEmailForm.invalid">Consultar</button>
            </div>
        </form>
    </section>
</div>

<!-- Modal de resultados usando el componente shared -->
<app-results-modal
    [isVisible]="isModalVisible"
    [title]="modalTitle"
    [results]="modalResults"
    [headerInfo]="modalHeaderInfo"
    (closed)="closeModal()">
</app-results-modal>